import { DmMonitoringControl } from './DmMonitoringControl';
import { useDmControlRoute } from './useDmControlRoute';

interface DmControlRouteProps {
    patientId: string;
    patientName: string;
}

// Renders the DM control modal whenever the URL asks for it; hosts only call `open()`.
export function DmControlRoute({ patientId, patientName }: DmControlRouteProps) {
    const route = useDmControlRoute(patientId);
    if (route.step === null) return null;
    return (
        <DmMonitoringControl
            patientId={patientId}
            patientName={patientName}
            step={route.step}
            onOpenTeeth={route.openTeeth}
            onLeaveTeeth={route.leaveTeeth}
            onClose={route.close}
        />
    );
}
